/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Carries the env's current image_mappings.json into the server render so
 * useImageMappings() can seed its initial state with the admin-uploaded
 * image URLs. Without this the SSR'd HTML contains the hardcoded DEFAULTS
 * (e.g. /images/hero-new.webp) and visitors see the default image briefly
 * before the client fetches /api/image-mappings and re-renders.
 *
 * On the client, the analogous seed comes from `window.__INITIAL_IMAGE_MAPPINGS__`
 * which the prerender step injects into the HTML.
 */

import React, { createContext, useContext } from 'react';

export type SSRImageMappings = Record<string, Record<string, string>>;

const SSRImageMappingsContext = createContext<SSRImageMappings | null>(null);

export const SSRImageMappingsProvider: React.FC<{
  value: SSRImageMappings | null;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <SSRImageMappingsContext.Provider value={value}>{children}</SSRImageMappingsContext.Provider>
);

export function useSSRImageMappings(): SSRImageMappings | null {
  return useContext(SSRImageMappingsContext);
}
